module.exports = __webpack_public_path__ + "efe6b8d16b4664d3e3589a798cbd8cf8.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sound/piano/11_A#2.mp3
// module id = 91
// module chunks = 0